export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14352.7fc7316e.jpg";